var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_ArrowScroll',{staticClass:"white",attrs:{"scroll-step":120}},[_c('div',{staticClass:"scrollable-tag-list-container"},_vm._l((_vm.tags),function(tag){return _c('Post_Tag',{key:tag.name,attrs:{"tag":tag}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }